import clsx from 'clsx';
import { ReactNode } from 'react';

interface Props extends BaseProps {
  children: ReactNode;
  className?: string;
  value: string | number;
}

export const SelectItem = ({
  children,
  className,
  name,
  value,
  ...rest
}: Props) => {
  return (
    <option
      className={clsx(className, 'hover:bg-primary px-2 py-1')}
      value={value}
      {...rest}
    >
      {children}
    </option>
  );
};
